import { render, staticRenderFns } from "./AppRefShareHead2.vue?vue&type=template&id=7a1c5a72&"
import script from "./AppRefShareHead2.vue?vue&type=script&lang=js&"
export * from "./AppRefShareHead2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports